import { createConversationSchema } from "Modules/conversation/createConversation/components/createConversationForm/schema";
import { ContactOptionType } from "Modules/conversation/createConversation/types";
import { bugsnagClient } from "Utils/logUtils";
import z from "zod";

export const useConversationErrors = () => {
  /**
   * Handles errors during form submission with proper logging and user feedback
   */
  const handleSubmissionError = (
    error: unknown,
    conversationType: string,
    data: z.infer<typeof createConversationSchema>,
    selectedContacts: ContactOptionType[]
  ) => {
    // Log error to Bugsnag for monitoring
    bugsnagClient.notify(new Error(error as string), (event) => {
      event.severity = 'error';
      event.context = 'CreateConversationForm';
      event.addMetadata('custom', {
        function: 'onSubmit',
        conversationType,
        participantCount: selectedContacts.length,
        hasGroupName: !!data.groupName?.trim(),
      });
    });

    // Log to console for development debugging
    console.error('Error in conversation creation:', {
      error,
      conversationType,
      participants: selectedContacts.length,
      groupName: data.groupName,
    });
  };

  /**
   * Handles general errors with proper logging
   */
  const handleGeneralError = (error: unknown, context: string) => {
    bugsnagClient.notify(new Error(error as string), (event) => {
      event.severity = 'error';
      event.context = 'CreateConversationForm';
      event.addMetadata('custom', { function: context });
    });

    console.error(`Error in ${context}:`, error);
  };

  return {
    handleSubmissionError,
    handleGeneralError,
  };
};